import React, { useState } from 'react'
import { WithTranslation, withTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { change, formValues } from 'redux-form'
import { Radio } from '../../../../components/FormBuilder'
import StatusRadio from '../../../../components/FormBuilder/Radio/StatusRadio'
import { EventStatus } from '../../../../models/Event'
import { Mixpanel } from '../../../../utils/Mixpanel'
import { useSelector } from 'react-redux'
import { getUserId } from '../../../../reducers/userAccount/selectors/userAccount'
import DisabledIcon2 from '../../../../assets/disabled.png'
import styled from '../../../../theme'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { PopoveredIcon2 } from '../../../../components/PopoveredIcon/PopoveredIcon'
import UpgradePremiumBlockScreenModal from '../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

function Status({
  formName,
  size = 1,
  status,
  airbnb = undefined,
  prepaidType,
  reservationStatus,
  disabled = false,
  id,
}: IDefaultStatusProps & WithTranslation) {
  const userId = useSelector(getUserId)
  const theme2 = useTheme()
  const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [popoverAnchor, setPopoverAnchor] = useState(null)

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }
  const NoPayment = Radio.CustomRedux(
    StatusRadio(
      EventStatus.NoPayment,
      status,
      null,
      size,
      'reservation-form-status-no-payment-radio',
    ),
  )
  const Advance = Radio.CustomRedux(
    StatusRadio(
      EventStatus.Advance,
      status,
      prepaidType,
      size,
      'reservation-form-status-advance-radio',
    ),
  )
  const FullPayment = Radio.CustomRedux(
    StatusRadio(
      EventStatus.Full,
      status,
      null,
      size,
      'reservation-form-status-full-radio',
    ),
  )
  const Canceled = Radio.CustomRedux(
    StatusRadio(
      EventStatus.Canceled,
      status,
      null,
      size,
      'reservation-form-status-canceled-radio',
    ),
  )
  const NoAvailable = Radio.CustomRedux(
    StatusRadio(
      EventStatus.Unavailable,
      status,
      null,
      size,
      'reservation-form-status-unavailable-radio',
    ),
  )

  function onClick(value: EventStatus) {
    return function() {
      Mixpanel.track('Reservation Form Status Changed', {
        'Reservation ID': Number(id),
        'Reservation Status': mapStatus(value),
      })
      Mixpanel.people.increment(userId, 'Reservation Status Changed', 1)
      if ('gtag' in window) {
        ;(window as any).gtag('event', 'conversion', {
          send_to: 'AW-927657230/J9nICOmWuZADEI7aq7oD',
        })
      }
      change(formName, 'reservationStatus', value)
    }
  }

  //this function map EventStatus to string
  function mapStatus(status: EventStatus) {
    switch (status) {
      case EventStatus.NoPayment:
        return 'Lack of payment'
      case EventStatus.Advance:
        return 'Down payment made'
      case EventStatus.Full:
        return ' Fully paid'
      case EventStatus.Canceled:
        return 'Cancelled'
      case EventStatus.Unavailable:
        return 'Unavailable'
      default:
        return 'Lack of payment'
    }
  }

  return (
    <Flex
      column={true}
      style={{ height: 'auto', marginTop: `${10 * size}px`, width: '100%' }}
      className={'settings-input-default_status'}
    >
      <LockWrapper
        disabled={disabled}
        onClick={isMobile ? () => setIsModalOpened(true) : handlePopoverOpen}
      >
        {disabled && <img src={DisabledIcon2} alt={'disabled icon'} style={{zIndex: 10}}/>}

        {!(airbnb && reservationStatus === EventStatus.Canceled) && (
          <NoPayment
            name={'reservationStatus'}
            width={'100%'}
            temporaryValue={EventStatus.NoPayment}
            onClick={onClick(EventStatus.NoPayment)}
            className={
              'settings-input-default_status-0 settings-input-default_status-no_payment'
            }
          />
        )}
        {!(airbnb && reservationStatus === EventStatus.Canceled) && (
          <Advance
            name={'reservationStatus'}
            width={'100%'}
            temporaryValue={EventStatus.Advance}
            onClick={onClick(EventStatus.Advance)}
            className={
              'settings-input-default_status-1 settings-input-default_status-advance'
            }
          />
        )}
        {!(airbnb && reservationStatus === EventStatus.Canceled) && (
          <FullPayment
            name={'reservationStatus'}
            width={'100%'}
            temporaryValue={EventStatus.Full}
            onClick={onClick(EventStatus.Full)}
            className={
              'settings-input-default_status-2 settings-input-default_status-full_payment'
            }
          />
        )}
        {!(airbnb && reservationStatus !== EventStatus.Canceled) && (
          <Canceled
            name={'reservationStatus'}
            width={'100%'}
            temporaryValue={EventStatus.Canceled}
            onClick={onClick(EventStatus.Canceled)}
            className={
              'settings-input-default_status-3 settings-input-default_status-canceled'
            }
          />
        )}

        {!(airbnb && reservationStatus === EventStatus.Canceled) && (
          <NoAvailable
            name={'reservationStatus'}
            width={'100%'}
            temporaryValue={EventStatus.Unavailable}
            onClick={onClick(EventStatus.Unavailable)}
            className={
              'settings-input-default_status-4 settings-input-default_status-no_available'
            }
          />
        )}
      </LockWrapper>
      <PopoveredIcon2
        withIcon={false}
        anchorEl={popoverAnchor}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      />
      {isMobile && (
        <UpgradePremiumBlockScreenModal
          open={isModalOpened}
          close={() => setIsModalOpened(false)}
        />
      )}
    </Flex>
  )
}

const LockWrapper = styled.div`
  position: relative;
  width: 100%;
  z-index: 0;

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    height: auto;
    width: 24px;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  &::after {
    content: '';
    display: ${({ disabled }) => (disabled ? 'block' : 'none')};
    position: absolute;
    inset: 0;
    background: rgba(215, 215, 215, 0.6);
    pointer-events: all;
    cursor: not-allowed;
    z-index: 999999;
  }
`

export default withTranslation()(formValues<any>({
  reservationStatus: 'reservationStatus',
})(Status) as any) as any

const DefaultStatus: any = withTranslation()(formValues<any>({
  reservationStatus: 'reservationStatus',
})(Status as any) as any)

export { DefaultStatus }

export interface IDefaultStatusProps {
  formName: string
  status?: any
  airbnb?: string
  prepaidType?: number
  size?: number
  id?: any
  disabled?: boolean
  reservationStatus?: EventStatus
}
